// extracted by mini-css-extract-plugin
module.exports = {"paragraph_container":"styles_paragraph_container__3zJI0"};